import React, { FC, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setEmployedsInfo, setInfoOrderDetail } from 'redux/ordersDetails/slice';
import { WhiteBlock } from 'components/WhiteBlock';
import { Title } from 'components/Title';
import { InputSearch } from 'ui/InputSearch';
import { InfoEmployedItem } from 'components/InfoEmployedItem';
import { ReactComponent as CrossIcon } from 'assets/img/iconCross.svg';
import styles from './EmployedsSearchBlock.module.scss';
import { EmpoyedTypes } from 'components/EmployedsList';
import { useGetWorkersQuery } from 'redux/Api/ordersApi/ordersApi';
import { ResponseGetWorkerType } from 'redux/Api/ordersApi/type';

type ChooseEmployedTypes = Omit<
  EmpoyedTypes,
  'created_at' | 'last_info_update' | 'nationality' | 'fns_status' | 'monthly_payment'
> & {
  fns_status?: number;
  worker_app?: ResponseGetWorkerType['worker_app'];
  monthly_payment?: number | null;
};

interface EmployedsSearchBlockTypes {
  worker: EmpoyedTypes[] | [];
  isReady?: boolean;
  workSupport?: boolean;
}

export const EmployedsSearchBlock: FC<EmployedsSearchBlockTypes> = ({ worker = [] }) => {
  const { data, isLoading } = useGetWorkersQuery();
  const [focus, setFocus] = useState(false);
  const [value, setValue] = useState('');
  const [chooseEmployeds, setChooseEmployeds] = useState<ChooseEmployedTypes[]>(
    worker?.length ? worker : [],
  );
  const dispatch = useDispatch();

  const listRef = useRef<HTMLDivElement>(null);

  const filtredArr = data?.data?.filter(
    (elem: ResponseGetWorkerType) =>
      elem?.name
        ?.replaceAll(' ', '')
        ?.toLowerCase()
        ?.includes(value?.replaceAll(' ', '').toLowerCase()) ||
      elem?.surname
        ?.replaceAll(' ', '')
        ?.toLowerCase()
        ?.includes(value?.replaceAll(' ', '').toLowerCase()) ||
      elem?.patronymic
        ?.replaceAll(' ', '')
        ?.toLowerCase()
        ?.includes(value?.replaceAll(' ', '').toLowerCase()),
  );

  const chooseHandler = (elem: ChooseEmployedTypes) => {
    setChooseEmployeds([elem]);
    dispatch(setEmployedsInfo(elem));
    dispatch(setInfoOrderDetail({ key: 'worker_id', value: elem.id }));
    setValue('');
  };

  const deleteEmployedHandler = () => {
    setChooseEmployeds([]);
    dispatch(setInfoOrderDetail({ key: 'worker_id', value: null }));
  };

  useEffect(() => {
    const clickOutside = (event: MouseEvent) => {
      if (listRef.current && !event.composedPath().includes(listRef.current)) {
        setValue('');
        setFocus(false);
      }
    };
    document.body.addEventListener('click', clickOutside);
    return () => document.body.removeEventListener('click', clickOutside);
  }, []);

  if (isLoading) {
    return <div>Загрузка...</div>;
  }

  return (
    <WhiteBlock>
      <div ref={listRef}>
        <div className={styles.blockTitle}>
          <Title title='Исполнитель' />
        </div>
        {!chooseEmployeds.length && (
          <InputSearch
            focus={focus}
            setFocus={setFocus}
            border
            value={value}
            placeholder='Искать по ИНН, ФИО или номеру телефона'
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setValue(e.target.value.trimStart())
            }
          />
        )}
        {focus && !!filtredArr?.length && !chooseEmployeds.length && (
          <div className={styles.list}>
            {filtredArr?.map((elem: ChooseEmployedTypes, i: number) => (
              <InfoEmployedItem
                chooseHandler={() => chooseHandler(elem)}
                key={i}
                fns_status={elem?.worker_app?.fns_status}
                fio={`${elem?.surname} ${elem?.name} ${elem?.patronymic || ''}`}
                inn={elem?.inn}
                phone={elem?.phone}
                workerAppStatus={elem?.worker_app?.app_status}
              />
            ))}
          </div>
        )}

        {!!chooseEmployeds.length && (
          <div className={styles.choose}>
            {!!chooseEmployeds.length &&
              chooseEmployeds?.map((elem: ChooseEmployedTypes, i: number) => (
                <InfoEmployedItem
                  chooseHandler={() => chooseHandler(elem)}
                  key={i}
                  fns_status={elem?.worker_app?.fns_status}
                  fio={`${elem?.surname} ${elem?.name} ${elem?.patronymic || ''}`}
                  inn={elem?.inn}
                  phone={elem?.phone}
                  workerAppStatus={elem?.worker_app?.app_status}
                />
              ))}
            <div onClick={deleteEmployedHandler} className={styles.choose_icon}>
              <CrossIcon />
            </div>
          </div>
        )}
      </div>
    </WhiteBlock>
  );
};
